<template>
  <div id="TopicInfoDialog_main">
    <el-dialog
      title="議案說明"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="info">
        {{ data }}
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data () {
    return {
      dialogVisible: false,
      data: ''
    }
  },
  methods: {
    openDialog (data) {
      this.dialogVisible = true
      this.data = data
    }
  }
}
</script>
<style lang="sass" scoped>
#TopicInfoDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 540px
    .info
      color: $mainFontColor
      font-size: 16px
      line-height: 24px
</style>
